<app-reset-button
  (btnClick)="_rsbs.resetClick.emit()"
  [isDisabled]="_rsbs.isResetDisabled$ | async"
  siteUsageTracker
  [logCategory]="'ResetSaveButtonGroup'"
  [logName]="'ResetClick'"
></app-reset-button>
<app-save-button
  [buttonText]="saveButtonText"
  [showTickIcon]="showTickIcon"
  (btnClick)="_rsbs.saveClick.emit()"
  [isDisabled]="_rsbs.isSaveDisabled$ | async"
  siteUsageTracker
  [logCategory]="'ResetSaveButtonGroup'"
  [logName]="'SaveClick'"
></app-save-button>
